import Totals from "../crew/Totals";
import GameTime from "../time/GameTime";
import Bonus from "./Bonus";

export default class BonusCreator {
    /**
     * @param {string} id
     */
    constructor(id, gameTime, totals) {
        /**
         * @constant
         * @type {string}
         */
        this.id = id;
        /**
         * @constant
         * @type {GameTime}
         */
        this.gameTime = gameTime;
        /**
         * @constant
         * @type {Totals}
         */
        this.totals = totals;
    }

    // IDEAS:
    // ore multipler
    // bonus multiplier
    // damage multiplier
    // 
    // temporary skills:
    // minions
    // dynamite
    // time acceleration
    // skills longer, skill cool downs

    /**
     * @abstract
     * @returns {Bonus}
     */
    createBonus() {
    }

    /**
     * @abstract
     * @param {number} activationValue
     * @returns {Bonus}
     */
    createBonusFromSave(activationValue) {
    }
    
}